/**
 * Created by CCristi on 7/15/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoleResolver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RoleVoter = require('./Voter/RoleVoter');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let RoleResolver = exports.RoleResolver = function () {
  /**
   * @param {RoleProvider} roleProvider
   */
  function RoleResolver(roleProvider) {
    _classCallCheck(this, RoleResolver);

    this._roleProvider = roleProvider;
  }

  /**
   * @param {String} context
   * @returns {Object}
   */


  _createClass(RoleResolver, [{
    key: 'resolve',
    value: function resolve(context) {
      return this.getContextVoters().then(voters => {
        for (let voter of voters) {
          if (voter.vote(context)) {
            return voter.role;
          }
        }

        return null;
      });
    }

    /**
     * @returns {Promise}
     */

  }, {
    key: 'getContextVoters',
    value: function getContextVoters() {
      return this._roleProvider.getRoles().then(roles => roles.map(r => new _RoleVoter.RoleVoter(r)));
    }
  }]);

  return RoleResolver;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/RoleResolver.js
// module id = 451
// module chunks = 0